
<script>
/**
 * mixin
 */
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      option: {
        font: {
          fontSize: 30,
          fontWeight: 'normal',
          fontStyle: 'italic',
          textDecoration: 'none',
          textAlign: 'center',
          color: '#000000'
        },
        opacity: 1
      },
    }
  },
  ...mapGetters([
    'TOOL',
    'SelectSprites_Msg',
    'SelectScenes_Msg',
  ]),
  methods: {
    updateSprite(font = {}) {

      if (!font || !Object.keys(font).length) {
        return;
      }

      if(this.sprite.artType) {
        // this.option.artStyle = this.getStyle(this.sprite.artType, this.option.font.color, this.option.font.fontSize)
      }
      return this.TOOL.updateSprite(this.sprite.id, { font }, this.sprite.scenesId, true);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/popupsNew/textSetting/base.vue